module.exports = __webpack_public_path__ + "img/07.70cb9360.png";